import * as yup from 'yup';

const userSchema = () => (
    yup.object().shape(
        {
            first_name: yup.string()
                .required('First name is Required')
                .matches(/^[aA-zZ\s]+$/, "Only letters are allowed")
                .max(20, 'Must be less than or equal to 20 characters long')
                .min(2, 'Must be at least 2 characters long'),
            last_name: yup.string()
                .required('Last name is Required')
                .matches(/^[aA-zZ\s]+$/, "Only letters are allowed")
                .max(20, 'Must be less than or equal to 20 characters long')
                .min(2, 'Must be at least 2 characters long'),
            email: yup.string()
                .email('Invalid email format').required('Email is Required'),
            password: yup.string()
                .required('Password is Required')
                .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])+.*$/, "Must be at least 8 characters long and uppercase letter")
                .min(8, 'Must be at least 8 characters long')
        }
    )
)

export default userSchema